"use client";

import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
} from "@/components/ui/pagination";
import { useSearch } from "@/contexts/SearchContext";
import { PropertyListingViewType } from "@/enums/property.enum";
import { PaginationResponse } from "@/interfaces/api.interface";
import { Property } from "@/interfaces/property.interface";
import clsx from "clsx";
import { useLocale, useTranslations } from "next-intl";
import ReactPaginate from "react-paginate";
import { useWindowSize } from "usehooks-ts";

export interface ListPaginationProps {
  data?: PaginationResponse<Property>;
}

export const ListPagination = (props: ListPaginationProps) => {
  const { data } = props;

  const locale = useLocale();
  const t = useTranslations("shared");

  const { width } = useWindowSize();
  const { view, updatePageParams, pageParams } = useSearch();

  const isMapsView = view === PropertyListingViewType.MAP;

  return (
    <Pagination className="w-full">
      <PaginationContent className="px-4 md:px-0">
        <ReactPaginate
          breakLabel={width < 768 ? null : <PaginationEllipsis />}
          pageCount={data?.meta?.totalPages ?? 0}
          nextLabel={t("words.next")}
          previousLabel={t("words.previous")}
          disabledLinkClassName="!cursor-not-allowed"
          disabledClassName="!cursor-not-allowed bg-muted !text-gray-600 hover:bg-tertiary"
          containerClassName={clsx(
            "inline-flex gap-4 items-center content-start ",
            {
              "flex-row-reverse": locale == "ar",
            }
          )}
          pageLinkClassName="py-2 px-3"
          previousClassName="py-2 px-3 text-gray-800 !text-sm rounded-md flex items-start content-start bg-tertiary text-tertiary-foreground hover:bg-tertiary/60 font-normal"
          nextClassName="py-2 px-3 text-gray-800 !text-sm rounded-md flex items-start content-start bg-tertiary text-tertiary-foreground hover:bg-tertiary/60 font-normal"
          pageClassName="rounded-md flex items-start content-start bg-tertiary text-tertiary-foreground hover:bg-tertiary/60 font-normal text-gray-800 !text-sm"
          activeClassName="!bg-primary !text-white"
          pageRangeDisplayed={width < 768 || isMapsView ? 3 : 3}
          marginPagesDisplayed={width < 768 || isMapsView ? 0 : 3}
          forcePage={pageParams.page - 1}
          onPageChange={({ selected }) => {
            if (typeof window !== "undefined") {
              window?.scrollTo({ top: 0 });
            }
            updatePageParams({ page: selected + 1 });
          }}
        />
      </PaginationContent>
    </Pagination>
  );
};
